import { DatePipe, NgClass } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  MatFormField,
  MatInput,
  MatPrefix,
  MatSuffix
} from '@angular/material/input';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { InlineSvgComponent } from '../../../components/inline-svg/inline-svg.component';
import { FileFilterBody } from '../../../models/general.models';
import {
  Project,
  ProjectFile
} from '../../../models/project.module';
import { User } from '../../../models/user.model';
import { ProjectService } from '../../../services/project.service';
import { CreateProjectModalComponent } from '../../risk-map/components/area-list/create-project-modal/create-project-modal.component';
import { FileFilterComponent } from './filter/filter.component';
import { NewProjectService } from '../../../services/newProject.service';

@Component({
  selector: 'frmg-project',
  templateUrl: './projectDetails.component.html',
  styleUrls: ['./projectDetails.component.scss'],
  imports: [
    InlineSvgComponent,
    NgClass,
    MatFormField,
    MatPrefix,
    MatInput,
    ReactiveFormsModule,
    MatSuffix,
    MatTooltip,
    MatMenuTrigger,
    MatMenu,
    FileFilterComponent,
    MatMenuItem,
    DatePipe
  ]
})
export class ProjectDetailsComponent implements OnInit {
  @Input() detailsId!: string;

  @ViewChild('filterTrigger') filterTrigger: MatMenuTrigger;

  public currentUser: User;
  public project: Project;
  public root: Project;
  public currentFiles: string = 'all';
  public menuState: string;
  public fileSearchCtrl: FormControl = new FormControl<string>('');

  public files: ProjectFile[] = [];
  public fileFilter: FileFilterBody = {
    file_format: null,
    date: null,
    ownership: []
  };
  public appliedFilterCount = 0;

  constructor(
    private projectService: ProjectService,
    private newProjectService: NewProjectService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user')) as User;
    this.fileSearchCtrl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((search) => {
        this.projectService
          .getProjectActivities(
            this.detailsId,
            this.currentFiles,
            this.fileFilter
          )
          .subscribe((activities) => {
            this.files = activities.results.filter((file) =>
              file.details.name.toLowerCase().includes(search.toLowerCase())
            );
          });
      });
  }

  ngOnInit(): void {
    this.getProjectInfo();
    // this.projectService.getProjectsByPath().subscribe((project) => {
    //   this.root = project;
    // });
  }

  private getProjectInfo() {
    this.newProjectService
      .getProjectManagementById(this.detailsId)
      .subscribe((project) => {
        this.project = project;
        this.cd.detectChanges();
      });
    // this.projectService
    //   .getProjectActivities(this.detailsId, this.currentFiles, this.fileFilter)
    //   .subscribe((activities) => {
    //     this.files = activities.results;
    //   });
    this.updateAppliedFilterCount();
  }

  public changeFileType(type: string) {
    this.currentFiles = type;
    this.projectService
      .getProjectActivities(this.detailsId, this.currentFiles, this.fileFilter)
      .subscribe((activities) => {
        this.files = activities.results;
      });
  }

  public clearSearch() {
    this.fileSearchCtrl.setValue('');
  }

  public toggleMenu(state: ProjectFile, event?: MouseEvent) {
    event && event.stopPropagation();
    this.menuState = state?.id;
  }

  public action(_file: any) {}

  public editProject(): void {
    const createProject = this.dialog.open(CreateProjectModalComponent, {
      data: {
        parent: this.root,
        project: this.project
      }
    });
    createProject.afterClosed().subscribe((resp) => {
      if (resp) {
        this.getProjectInfo();
      }

      this.cd.detectChanges();
    });
  }

  public getProjectIconPath(project: Project) {
    if (
      project &&
      this.currentUser.email === project.user.email &&
      !project.is_archived
    ) {
      return 'project.svg';
    } else if (project?.is_archived) {
      return 'archived.svg';
    } else {
      return 'Shared.svg';
    }
  }

  public getAppliedFilter() {
    return this.appliedFilterCount > 0;
  }

  public closeFilter() {
    this.filterTrigger.closeMenu();
  }

  public onApplyFilter(filter: FileFilterBody) {
    this.fileFilter = filter;
    this.projectService
      .getProjectActivities(this.detailsId, this.currentFiles, this.fileFilter)
      .subscribe((activities) => {
        this.files = activities.results;
      });
    this.updateAppliedFilterCount();
  }

  public downloadFile(file: ProjectFile) {
    window.open(file.details.s3_url, '_blank');
  }

  private updateAppliedFilterCount() {
    let count = 0;
    if (this.fileFilter?.file_format) count++;
    const hasDate = !!(
      this.fileFilter?.date &&
      (this.fileFilter.date.from || this.fileFilter.date.to)
    );
    if (hasDate) count++;
    if (this.fileFilter?.ownership && this.fileFilter.ownership.length > 0)
      count++;
    this.appliedFilterCount = count;
  }
}
